import React from 'react';
import { Icon, RoundedButton } from "../../../..";
import { DISPLAY_MODE } from "../../../../../components/app/consts";

const ModeSwitcher = ({ mode, setMode }) => {
  return (
    <>
      <RoundedButton outline={true} onClick={() => setMode(DISPLAY_MODE.GRID)} height="40px">
        <Icon name={"grid"} height={"14px"} width={"14px"} />
      </RoundedButton>
      <RoundedButton outline={true} onClick={() => setMode(DISPLAY_MODE.TABLE)} height="40px">
        <Icon name={"table"} height={"14px"} width={"14px"} />
      </RoundedButton>
    </>
  );
};

export default ModeSwitcher; 